module.exports = __webpack_public_path__ + "media/images/icons/arrow_no_fill-fe7dbd2711fdbdf3ff2930f9a590f015.svg";